// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ai-tabs {
  display: block;
  margin-top: 0.75rem;
}

:host ::ng-deep {
  /* Remove default PrimeNG / browser focus ring on listbox (sky blue outline) when selecting options */
}
:host ::ng-deep .gc-form-section {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  margin-bottom: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form {
  padding: 25px;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1e38a9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown .p-dropdown-label {
  padding: 12px 16px;
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
}
:host ::ng-deep .ai-composer-listbox-wrap {
  width: 100%;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-family: "Montserrat", sans-serif;
  overflow: hidden;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox.p-focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus-visible,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus-within,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus-visible {
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item.p-focus {
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-header {
  padding: 0.65rem 0.75rem 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  justify-content: flex-start;
  background: #f3f4f6;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
:host ::ng-deep .ai-composer-listbox-select-all-row {
  width: 100%;
}
:host ::ng-deep .ai-composer-listbox-select-all {
  color: #0f63ac;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}
:host ::ng-deep .ai-composer-listbox-select-all:hover {
  text-decoration: underline;
}
:host ::ng-deep .ai-composer-listbox-placeholder-text {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.4;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list-wrapper {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item {
  padding: 0.5rem 0.75rem;
  font-size: 15px;
  color: #1f2937;
  background: #fff;
  gap: 0.625rem;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item > .p-checkbox {
  flex-shrink: 0;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-empty-message {
  padding: 0rem 0.75rem;
  font-size: 14px;
  color: #6b7280;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox p-scroller .p-scroller {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
:host ::ng-deep .p-chips {
  width: 100%;
}
:host ::ng-deep .p-chips .p-chips-multiple-container {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  min-height: 54px;
  padding: 8px 12px;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  text-align: center;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.active-row {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.guideline-info {
  color: #9ca3af;
  font-size: 0.85rem;
}

.guideline-help {
  font-size: 14px;
  color: #6b7280;
  margin: 0.25rem 0 0.75rem 0;
}

.guide-link {
  color: #1e38a9;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.change-history-box {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  max-height: 180px;
  overflow: auto;
  background: #fff;
}

.change-history-entry {
  padding: 10px 12px;
  font-size: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.change-history-entry:last-child {
  border-bottom: none;
}

.prompt-guide-content {
  max-height: calc(100vh - 170px);
  overflow: auto;
  padding: 0 1rem;
  font-size: 16px;
  line-height: 1.6;
}

.prompt-guide-content h4 {
  color: #1f2937;
  margin-top: 1.1rem;
  margin-bottom: 0.5rem;
  font-size: 32px;
  font-weight: 700;
}

.prompt-guide-content h5 {
  margin: 0 0 0.35rem;
  font-size: 16px;
  font-weight: 700;
}

.prompt-guide-content p {
  margin: 0 0 0.65rem;
  color: #374151;
}

.good-list,
.mistakes-list,
.checklist {
  margin: 0 0 1rem;
  padding-left: 0;
  list-style: none;
}

.good-list li,
.mistakes-list li,
.checklist li {
  margin: 0.4rem 0;
  padding-left: 1rem;
  position: relative;
}

.good-list li::before {
  content: "•";
  color: #2563eb;
  position: absolute;
  left: 0;
}

.mistakes-list li::before {
  content: "X";
  color: #dc2626;
  position: absolute;
  left: 0;
}

.checklist li::before {
  content: "☐";
  color: #9ca3af;
  position: absolute;
  left: 0;
}

.principles-list {
  padding-left: 1.2rem;
}

.principles-list li {
  margin-bottom: 0.85rem;
}

.principles-list p {
  margin-top: 0.25rem;
  color: #6b7280;
  font-style: italic;
}

.role-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.9rem 1rem;
  margin-bottom: 0.85rem;
}

.role-card ul {
  margin: 0;
  padding-left: 1rem;
}

.role-card li {
  margin: 0.2rem 0;
}

.template-box {
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  white-space: pre-line;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}

/* Create/update guideline fields spacing */
:host ::ng-deep .sidebar-form input[formControlName=templateTitle] {
  margin-bottom: 0.75rem;
}

:host ::ng-deep .sidebar-form textarea[formControlName=style_guide] {
  margin-bottom: 0.75rem;
}

:host ::ng-deep .sidebar-form p-dropdown[formControlName=questionType] {
  display: block;
  margin-bottom: 1.5rem;
}

.body-column-cell {
  max-width: 520px;
}

.body-column-text {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.45;
  max-height: 4.35em;
}

.visit-code-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #1e38a9;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin: 2px 6px 2px 0;
  border: 1px solid #cdd7ff;
}

:host ::ng-deep .p-chips .p-chips-token {
  margin: 2px 6px 2px 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #2d3f9f;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

:host ::ng-deep .p-chips .p-chips-token .p-chips-token-icon {
  color: #ffffff;
  font-size: 12px;
  margin-left: 6px;
}

.idg-tab-label {
  display: inline-flex;
  align-items: center;
  cursor: not-allowed;
}

::ng-deep .ai-tabs .p-tabview-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 0 0 0.625rem 0;
  padding: 0 1rem;
  border-bottom: 1px solid #d9d9d9;
}

::ng-deep .ai-tabs .p-tabview-nav li {
  margin: 0;
}

::ng-deep .ai-tabs .p-tabview-nav li .p-tabview-nav-link {
  min-height: 2rem;
  line-height: 1;
  font-weight: 600;
  color: #495057;
}

::ng-deep .ai-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #00a651;
  border-color: #00a651;
}

::ng-deep .ai-tabs .p-tabview-panels {
  padding-top: 0.125rem;
}

.idg-placeholder {
  padding: 2rem;
  text-align: center;
  color: #666;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
